import React from "react";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import * as BackEndConsts from "tools/constants/backEndConstants";
import {
  handleDate,
  platformNotifMessages,
  debugLog
} from "tools/commonFunctions";
import { dataService } from "tools/dataService/dataService"
import { trackPromise } from "react-promise-tracker";
import UserContextInfo from "tools/userContextInfo";
import {
  areConfigValuesEqual,
  diffKeyValueConfig,
  isKeyValueConfig
} from "tools/keyValueConfig";

import {
  UncontrolledTooltip,
  UncontrolledCollapse,
  Button
} from "reactstrap";

import i18next from 'i18next';

import { LainoSwitch } from "components/Switch/Switch";

import AppComponent from "./AppComponent";
import GenericModal from "components/Modal/GenericModal";
import ThemeContext from "contexts/ThemeContext";
class ServiceApp extends React.Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);

    this.state = {
      appId: this.props.app.id,
      appName: this.props.app.name,
      appState: this.props.app.state,
      appEditable: this.props.app.editable,
      appActivation: this.props.app.enabled,
      appDeployCode: this.props.app.deploymentstateinfo.code,
      appDeployStatus: this.props.app.deploymentstateinfo.codeinfo,
      appNotifError: this.props.app.deploynotificationerror,
      appDeployOwner: this.props.app.deployby,
      appDeployDate: this.props.app.deploydate
        ? handleDate(this.props.app.deploydate).dateFormatted
        : "",
      appDeployDuration: this.props.app.deployduration,
      appOnlineUsers: this.props.app.onlineusercount,
      appFinishState: this.props.app.deployfinishedstate,
      appNotifications: this.props.app.notifications,
      appTooltip: this.props.app.tooltip,
      // Tolerance to null in security: Secure fallback when backend returns null
      appSecClusterEnabled: (this.props.app.security && this.props.app.security.tool) ? this.props.app.security.tool : false,
      appSecTerminalEnabled: (this.props.app.security && this.props.app.security.console) ? this.props.app.security.console : false,
      appSecIsAdmin: (this.props.app.security && this.props.app.security.admin) ? this.props.app.security.admin : false,
      appComponents: this.props.app.appcomponents,
      deployButtonDisable: true,
      deployButtonCaption: "",
      endPointsModal: false,
      servicesDisabled: true,
      componentUpdated: false,
      dirtyComponents: new Map(), // Track dirty state of child components
      batchSaveModalOpen: false,
      componentResetVersions: new Map(), // Track reset versions to force component re-render
      batchValidationCounter: 0,
      rollbackModalOpen: false,
      rollbackModalConfirmDiscard: false,
      rollbackSnapshot: null,
      rollbackReason: "",
      pendingComponentValues: new Map() // Values kept by the user after a rolled back deployment
    }

    // Values sent by the last batch deployment, kept in memory so a rollback can
    // offer them back. Never persisted: they may contain secret values.
    this.deployAttemptSnapshot = null;
    // First ROLLEDBACK poll resets the form; later polls must not wipe Keep.
    this.rollbackFlowStarted = false;
    // Toast or keep/discard modal already shown for the current rollback.
    this.rollbackOutcomeNotified = false;

    this.toggleModal = this.toggleModal.bind(this);
    this.endPointsRequest = this.endPointsRequest.bind(this);
    this.handleTerminals = this.handleTerminals.bind(this);
    this.requestDeployLoop = this.requestDeployLoop.bind(this);
  }

  componentDidMount() {
    const t = this.props.t;
    let app = this.props.app;

    this.getAppData();

    this.setState({
      deployButtonDisable: app.state === "INACTIVE" ? true : false,
      deployButtonCaption: app.state !== "UPDATING" ? t("platformService.serviceApp.deploy") : "",
      servicesDisabled: app.state !== "ACTIVE" ? true : false
    })

    //Call to refresh deployment data every X seconds until state not being UPDATING
    if (app.state === "UPDATING") {
      let intervalTiming = 5000;

      if (localStorage.getItem(['IntervalId-' + app.id])) {
        let CurrentIntervalId = localStorage.getItem(['IntervalId-' + app.id]);
        clearInterval(CurrentIntervalId);
        this.requestDeployLoop(app.state, app.id, intervalTiming);
      } else this.requestDeployLoop(app.state, app.id, intervalTiming);

    } else return null
  };

  componentDidUpdate() {
    let appState = this.state.appState;
    let id = ('accordion-' + this.state.appId);
    if (appState === "UPDATING") {
      let element = document.getElementById(id)
      if (element !== undefined) {
        element.classList.remove("show");
      } else return null
    }
  }

  getAppData() {
    const t = this.props.t;

    return trackPromise(
      dataService.queries.getServiceAppData(this.props.app.id).then(
        (dataapp) => {
          if (!dataapp || !Array.isArray(dataapp.appcomponents)) {
            return;
          }

          let compoProtocolObject = [];
          dataapp.appcomponents.map(
            (appComponent) => {
              appComponent.appcomponentprotocols.map(
                (compoProtocol) => {
                  if (compoProtocol.enabled) {
                    compoProtocolObject.push({
                      id: compoProtocol.id
                    })
                  } else null
                })
            })

          this.setState({
            appId: dataapp.id,
            appName: dataapp.name,
            appState: dataapp.state,
            appEditable: dataapp.editable,
            appActivation: dataapp.enabled,
            appDeployCode: dataapp.deploymentstateinfo.code,
            appDeployStatus: dataapp.deploymentstateinfo.codeinfo,
            appNotifError: dataapp.deploynotificationerror,
            appDeployOwner: dataapp.deployby,
            appDeployDate: dataapp.deploydate
              ? handleDate(dataapp.deploydate).dateFormatted
              : "",
            appDeployDuration: dataapp.deployduration,
            appOnlineUsers: dataapp.onlineusercount,
            appFinishState: dataapp.deployfinishedstate,
            appNotifications: dataapp.notifications,
            appClusters: dataapp.appclusters,
            appK8Endpoints: dataapp.k8endpoints,
            platformAppCACRT: dataapp.companyservice.kubeplatform.company.cacrt,
            platformStorages: dataapp.companyservice.kubeplatform.k8storages,
            platformLabels: dataapp.companyservice.kubeplatform.k8labels,
            appComponents: dataapp.appcomponents,
            componentProtocolId: compoProtocolObject.length > 0
              ? compoProtocolObject[0].id
              : null,
            deployButtonDisable: dataapp.state === "INACTIVE" ? true : false,
            deployButtonCaption: dataapp.state !== "UPDATING" ? t("platformService.serviceApp.deploy") : "",
            servicesDisabled: dataapp.state !== "ACTIVE" ? true : false
          })
        }
      )
    )
  }

  sendDeploy(appId) {
    const t = this.props.t;

    trackPromise(
      dataService.mutations.deployServiceApp(appId).then(
        (datadeploy) => {
          if (datadeploy === BackEndConsts.BACKEND_RESPONSE_ERROR) {
            this.setState({
              appActivation: !this.state.appActivation
            })
          } else {
            let datadeployAppData = datadeploy.companyserviceapp;
            let compoProtocolObject = []
            datadeployAppData.appcomponents.map(
              (appComponent) => {
                appComponent.appcomponentprotocols.map(
                  (compoProtocol) => {
                    if (compoProtocol.enabled) {
                      compoProtocolObject.push({
                        id: compoProtocol.id
                      })
                    } else null
                  })
              })

            this.setState({
              appId: datadeployAppData.id,
              appEditable: datadeployAppData.editable,
              appState: datadeployAppData.state,
              appActivation: datadeployAppData.enabled,
              appDeployMessage: datadeployAppData.deploymentstateinfo.message,
              appDeployMessageLevel: datadeployAppData.deploymentstateinfo.messagelevel,
              appDeployMessageTitle: datadeployAppData.deploymentstateinfo.messagetitle,
              appNotifError: datadeployAppData.deploynotificationerror,
              appDeployOwner: datadeployAppData.deployby,
              appDeployDate: datadeployAppData.deploydate
                ? handleDate(datadeployAppData.deploydate).dateFormatted
                : "",
              appDeployDuration: datadeployAppData.deployduration,
              appOnlineUsers: datadeployAppData.onlineusercount,
              appFinishState: datadeployAppData.deployfinishedstate,
              appNotifications: datadeployAppData.notifications,
              appComponents: datadeployAppData.appcomponents,
              componentProtocolId: compoProtocolObject.length > 0
                ? compoProtocolObject[0].id
                : null,
              componentProtocols: compoProtocolObject,
              settingsOpened: false,
              deployButtonDisable: datadeployAppData.state === "UPDATING" ? true : false,
              deployButtonCaption: datadeployAppData.state !== "UPDATING" ? t("platformService.serviceApp.deploy") : "",
              servicesDisabled: (datadeployAppData.state !== "ACTIVE"
                || this.state.appSecClusterEnabled === false) ? true : false
            });

            platformNotifMessages(
              this.state.appDeployMessageLevel,
              this.state.appDeployMessageTitle,
              this.state.appDeployMessage,
              this.props.app.name)

            //Call to refresh deployment data every X seconds until state not being UPDATING
            this.requestDeployLoop(datadeployAppData.state, datadeployAppData.id, 10000);
          }
        }
      )
    )
  }

  sendDelete(appId) {
    const t = this.props.t;

    trackPromise(
      dataService.mutations.deleteServiceApp(appId).then(
        (datadelete) => {
          if (datadelete === BackEndConsts.BACKEND_RESPONSE_ERROR) {
            this.setState({
              appActivation: !this.state.appActivation
            })
          } else {
            let datadeleteAppData = datadelete.companyserviceapp;
            let compoProtocolObject = []
            datadeleteAppData.appcomponents.map(
              (appComponent) => {
                appComponent.appcomponentprotocols.map(
                  (compoProtocol) => {
                    if (compoProtocol.enabled) {
                      compoProtocolObject.push({
                        id: compoProtocol.id
                      })
                    } else null
                  })
              })

            this.setState({
              appId: datadeleteAppData.id,
              appEditable: datadeleteAppData.editable,
              appState: datadeleteAppData.state,
              appActivation: datadeleteAppData.enabled,
              appDeployMessage: datadeleteAppData.deploymentstateinfo.message,
              appDeployMessageLevel: datadeleteAppData.deploymentstateinfo.messagelevel,
              appDeployMessageTitle: datadeleteAppData.deploymentstateinfo.messagetitle,
              appNotifError: datadeleteAppData.deploynotificationerror,
              appDeployOwner: datadeleteAppData.deployby,
              appDeployDate: datadeleteAppData.deploydate
                ? handleDate(datadeleteAppData.deploydate).dateFormatted
                : "",
              appDeployDuration: datadeleteAppData.deployduration,
              appOnlineUsers: datadeleteAppData.onlineusercount,
              appFinishState: datadeleteAppData.deployfinishedstate,
              appNotifications: datadeleteAppData.notifications,
              appComponents: datadeleteAppData.appcomponents,
              componentProtocolId: compoProtocolObject.length > 0
                ? compoProtocolObject[0].id
                : null,
              componentProtocols: compoProtocolObject,
              deployButtonDisable: datadeleteAppData.state === "INACTIVE" ? true : false,
              deployButtonCaption: datadeleteAppData.state !== "UPDATING" ? t("platformService.serviceApp.deploy") : "",
              servicesDisabled: (datadeleteAppData.state !== "ACTIVE"
                || this.state.appSecClusterEnabled === false) ? true : false
            });

            platformNotifMessages(
              this.state.appDeployMessageLevel,
              this.state.appDeployMessageTitle,
              this.state.appDeployMessage,
              this.props.app.name)

            //Call to refresh deployment data every X seconds until state not being UPDATING
            this.requestDeployLoop(datadeleteAppData.state, datadeleteAppData.id, 10000);
          }
        }
      )
    )
  }

  buildRollbackUiReset(appComponents) {
    const newResetVersions = new Map(this.state.componentResetVersions);
    (appComponents || []).forEach((component) => {
      if (component && component.id) {
        newResetVersions.set(component.id, (newResetVersions.get(component.id) || 0) + 1);
      }
    });

    return {
      dirtyComponents: new Map(),
      pendingComponentValues: new Map(),
      componentResetVersions: newResetVersions,
      batchSaveModalOpen: false
    };
  }

  getDeployStatus(appId, intervalID, callNotif) {
    const t = this.props.t;

    //Loop query without the trackpromise to not show the spinner
    dataService.queries.getServiceAppData(appId).then(
      (dataapp) => {
        if (!dataapp || !Array.isArray(dataapp.appcomponents)) {
          return;
        }

        let compoProtocolObject = []
        dataapp.appcomponents.map(
          (appComponent) => {
            appComponent.appcomponentprotocols.map(
              (compoProtocol) => {
                if (compoProtocol.enabled) {
                  compoProtocolObject.push({
                    id: compoProtocol.id
                  })
                } else null
              })
          })

        const isRolledBack = dataapp.deploymentstateinfo.code === BackEndConsts.DEPLOYMENT_STATE_ROLLEDBACK;
        let rollbackUiReset = {};
        if (isRolledBack) {
          if (!this.rollbackFlowStarted) {
            this.rollbackFlowStarted = true;
            rollbackUiReset = this.buildRollbackUiReset(dataapp.appcomponents);
          }
        } else {
          this.rollbackFlowStarted = false;
          this.rollbackOutcomeNotified = false;
        }

        this.setState({
          appState: dataapp.state,
          appEditable: dataapp.editable,
          appActivation: dataapp.enabled,
          appDeployCode: dataapp.deploymentstateinfo.code,
          appDeployStatus: dataapp.deploymentstateinfo.codeinfo,
          appDeployMessage: dataapp.deploymentstateinfo.message,
          appDeployMessageLevel: dataapp.deploymentstateinfo.messagelevel,
          appDeployMessageTitle: dataapp.deploymentstateinfo.messagetitle,
          appNotifError: dataapp.deploynotificationerror,
          appDeployOwner: dataapp.deployby,
          appDeployDate: dataapp.deploydate
            ? handleDate(dataapp.deploydate).dateFormatted
            : "",
          appDeployDuration: dataapp.deployduration,
          appOnlineUsers: dataapp.onlineusercount,
          appFinishState: dataapp.deployfinishedstate,
          appNotifications: dataapp.notifications,
          appComponents: dataapp.appcomponents,
          componentProtocolId: compoProtocolObject.length > 0
            ? compoProtocolObject[0].id
            : null,
          componentProtocols: compoProtocolObject,
          appK8Endpoints: dataapp.k8endpoints,
          platformAppCACRT: dataapp.companyservice.kubeplatform.company.cacrt,
          platformStorages: dataapp.companyservice.kubeplatform.k8storages,
          platformLabels: dataapp.companyservice.kubeplatform.k8labels,

          intervalID: intervalID,

          deployButtonDisable: dataapp.state === "INACTIVE" ? true : false,
          deployButtonCaption: dataapp.state !== "UPDATING" ? t("platformService.serviceApp.deploy") : "",
          servicesDisabled: (dataapp.state !== "ACTIVE"
            || this.state.appSecClusterEnabled === false) ? true : false,
          ...rollbackUiReset
        }, () => {
          if (isRolledBack && this.props.onAppDirtyStateChange) {
            this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, false);
          }
        })

        if (dataapp.state === "UPDATING") {
          localStorage.setItem(['IntervalId-' + appId], intervalID);

          if (callNotif !== false) {
            return (
              platformNotifMessages(
                this.state.appDeployMessageLevel,
                this.state.appDeployMessageTitle,
                this.state.appDeployMessage,
                this.props.app.name)
            );
          } else return null;
        } else if (dataapp.deployfinishedstate.length !== 0) {
          return (
            this.handleDeploymentFinishedState(
              intervalID,
              dataapp.deploymentstateinfo.code,
              dataapp.deploymentstateinfo.messagelevel,
              dataapp.deploymentstateinfo.messagetitle,
              dataapp.deploymentstateinfo.message,
              dataapp.deployfinishedstate
            )
          );
        } else return null;
      }
    )
  };

  requestDeployLoop(deployStatus, appId, intervalTiming) {
    let intervalfunc = this.getDeployStatus.bind(this);
    let intervalLoop = function () {
      if (deployStatus === "UPDATING") {
        return (
          // eslint-disable-next-line
          localStorage.setItem(['IntervalId-' + appId], interval),
          intervalfunc(appId, interval, false)
        );
      }
      else return (
        clearInterval(interval)
      )
    };
    let interval = setInterval(intervalLoop, intervalTiming);
    intervalLoop();
  }

  handleCheckboxChange = (e) => {
    let appId = this.state.appId;
    this.setState({
      appActivation: !this.state.appActivation,
      settingsOpened: false,
      appState: "UPDATING"
    })
    e === true ? this.sendDeploy(appId) : this.sendDelete(appId);
  };

  handleDeploymentFinishedState = (
    intervalID,
    deployCode,
    messagelevel,
    messagetitle,
    message,
    finishState) => {

    let reason = this.state.appNotifError;

    switch (deployCode) {
      case BackEndConsts.DEPLOYMENT_STATE_ROLLEDBACK:
        message = reason;
        break;
      default:
        break;
    }
    if (finishState) {
      clearInterval(intervalID);
      localStorage.removeItem(['IntervalId-' + this.state.appId]);

      this.setState((prevState) => ({
        appFinishedState: finishState,
        settingsOpened: false,
        componentUpdated: !prevState.componentUpdated
      }));

      const isRolledBack = deployCode === BackEndConsts.DEPLOYMENT_STATE_ROLLEDBACK;
      const snapshot = this.deployAttemptSnapshot;
      this.deployAttemptSnapshot = null;

      // A rollback that undid user edits deserves more than a toast: the user
      // chooses whether to keep the attempted values for a retry or drop them.
      if (isRolledBack && snapshot) {
        this.rollbackOutcomeNotified = true;
        this.openRollbackChoiceModal(snapshot, message);
        return null;
      }

      // Later polls of an already handled rollback must not raise the toast again.
      if (isRolledBack && (this.state.rollbackModalOpen || this.rollbackOutcomeNotified)) {
        return null;
      }

      if (isRolledBack) {
        this.rollbackOutcomeNotified = true;
      }

      return platformNotifMessages(
        messagelevel,
        messagetitle,
        message,
        this.props.app.name
      );
    }
    return null;
  }

  // Snapshot of a deploy attempt: the server baseline of every component being
  // updated plus the values the user tried to apply.
  buildDeployAttemptSnapshot = (dirtyComponents, appComponents) => {
    const clone = (value) => JSON.parse(JSON.stringify(value));
    const entries = [];
    const baseline = [];

    dirtyComponents.forEach((data, componentId) => {
      const original = (appComponents || []).find((c) => String(c.id) === String(componentId));
      if (!original || !data || !data.values) return;

      entries.push([
        original.id,
        {
          componentName: data.componentName,
          values: clone(data.values),
          isValid: true,
          validationErrors: {}
        }
      ]);
      baseline.push(clone(original));
    });

    return entries.length > 0 ? { entries, baseline } : null;
  }

  // The backend rollback only restores pods, load balancer and hardware resources,
  // so configs and secrets written by the failed attempt would stay in the database
  // while the cluster runs the previous ones. These mutations persist values without
  // triggering a deployment, which is exactly what is needed to realign both sides.
  restoreConfigsAndSecrets = (snapshot) => {
    if (!snapshot) return Promise.resolve("skipped");

    const pending = [];

    snapshot.entries.forEach(([componentId, data]) => {
      const original = snapshot.baseline.find((c) => String(c.id) === String(componentId));
      if (!original) return;

      (data.values.componentConfiguration || []).forEach((cfg) => {
        const orig = (original.appcomponentconfigs || []).find((o) => String(o.id) === String(cfg.id));
        if (!orig) return;
        const originalValue = orig.value == null ? "" : String(orig.value);
        const nextValue = cfg.value == null ? "" : String(cfg.value);
        const configType = cfg.configtype || orig.configtype;
        if (areConfigValuesEqual(originalValue, nextValue, configType)) return;
        pending.push(dataService.mutations.updateAppComponentConfig(cfg.id, originalValue));
      });

      (data.values.componentSecrets || []).forEach((sec) => {
        const orig = (original.appcomponentsecrets || []).find((o) => String(o.id) === String(sec.id));
        if (!orig) return;
        const originalValue = orig.value == null ? "" : String(orig.value);
        if (String(sec.value == null ? "" : sec.value) === originalValue) return;
        pending.push(dataService.mutations.updateAppComponentSecret(sec.id, originalValue));
      });
    });

    if (pending.length === 0) return Promise.resolve("skipped");
    return Promise.all(pending).then(() => "restored").catch(() => "failed");
  }

  openRollbackChoiceModal = (snapshot, reason) => {
    const showModal = () => {
      this.setState({
        rollbackSnapshot: snapshot,
        rollbackReason: reason || "",
        rollbackModalConfirmDiscard: false,
        rollbackModalOpen: true
      });
    };

    // The refresh must settle before the modal opens: otherwise a late state
    // update could overwrite the values the user just chose to keep.
    this.restoreConfigsAndSecrets(snapshot).then((result) => {
      if (result === "failed") {
        const t = this.props.t;
        platformNotifMessages(
          "DANGER",
          t("common.error"),
          t("platformService.serviceApp.rollbackModal.restoreError"),
          this.state.appName
        );
        showModal();
        return;
      }
      if (result !== "restored") {
        showModal();
        return;
      }
      this.getAppData().then(showModal, showModal);
    });
  }

  // Keeping the values leaves the app exactly as before the attempt on the server
  // and repopulates the form as dirty, so the user can adjust and redeploy without
  // configuring everything again.
  handleRollbackKeepValues = () => {
    if (!this.state.rollbackSnapshot) {
      this.handleRollbackDiscardValues();
      return;
    }

    this.setState((prevState) => {
      const dirtyComponents = new Map();
      const pendingComponentValues = new Map();
      const componentResetVersions = new Map(prevState.componentResetVersions);

      prevState.rollbackSnapshot.entries.forEach(([componentId, data]) => {
        dirtyComponents.set(componentId, {
          componentName: data.componentName,
          values: data.values,
          isValid: true,
          validationErrors: {}
        });
        pendingComponentValues.set(String(componentId), data.values);
        componentResetVersions.set(componentId, (componentResetVersions.get(componentId) || 0) + 1);
      });

      return {
        dirtyComponents,
        pendingComponentValues,
        componentResetVersions,
        settingsOpened: true,
        rollbackModalOpen: false,
        rollbackModalConfirmDiscard: false,
        rollbackSnapshot: null,
        rollbackReason: ""
      };
    }, () => {
      if (this.props.onAppDirtyStateChange) {
        this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, this.state.dirtyComponents.size > 0);
      }
    });
  }

  // Discarding needs no extra mutation: the database already holds the pre-attempt
  // values, so the components are just remounted from the server data.
  handleRollbackDiscardValues = () => {
    this.setState((prevState) => {
      const componentResetVersions = new Map(prevState.componentResetVersions);
      const entries = prevState.rollbackSnapshot ? prevState.rollbackSnapshot.entries : [];
      entries.forEach(([componentId]) => {
        componentResetVersions.set(componentId, (componentResetVersions.get(componentId) || 0) + 1);
      });

      return {
        dirtyComponents: new Map(),
        pendingComponentValues: new Map(),
        componentResetVersions,
        rollbackModalOpen: false,
        rollbackModalConfirmDiscard: false,
        rollbackSnapshot: null,
        rollbackReason: ""
      };
    }, () => {
      if (this.props.onAppDirtyStateChange) {
        this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, false);
      }
    });
  }

  // Closing the modal without choosing means discarding, so it asks for confirmation.
  toggleRollbackModal = () => {
    this.setState((prevState) => ({
      rollbackModalConfirmDiscard: !prevState.rollbackModalConfirmDiscard
    }));
  }

  cancelRollbackDiscardConfirmation = () => {
    this.setState({ rollbackModalConfirmDiscard: false });
  }

  renderSwitchButton = () => {
    let isAccountActivated = UserContextInfo.activeCompanyActivation()
    let isAdmin = this.state.appSecIsAdmin;
    let disableStyles = this.state.appState !== "UPDATING" ? "" : "disabled disabled"

    if (isAdmin !== true || isAccountActivated !== "ACTIVATED") {
      return (
        <>
          <LainoSwitch
            disabled={true}
            checked={this.state.appActivation}
            onChange={this.handleCheckboxChange}
            disableStyles="disabled disabled"
            hexColor={this.props.hexColor}
          />
        </>
      );
    } else return (
      <>
        <LainoSwitch
          disabled={this.state.appState === "UPDATING" ? true : false}
          checked={this.state.appActivation}
          onChange={this.handleCheckboxChange}
          disableStyles={disableStyles}
          hexColor={this.props.hexColor}
        />
      </>
    )
  };

  toggleModal = (arg) => {
    if (arg && arg.fromModalClose && arg.name) {
      this.setState({
        [arg.name]: false,
        endPointsModal: false
      });
      return;
    }

    if (arg && arg.persist) {
      arg.persist();
    }

    let name = arg && arg.target ? arg.target.name : undefined;
    let state = arg && arg.target ? arg.target.value : undefined;

    this.setState({
      [name]: state === "true" ? false : true,
      endPointsModal: !this.state.endPointsModal
    });
  }

  toggleSettingsSection = () => {
    this.setState({
      settingsOpened: !this.state.settingsOpened
    })
  }

  endPointsRequest() {
    const t = this.props.t;

    this.setState(prevState => ({
      modalTitleText: t("platformService.serviceApp.endPointModal.endPointTitle", { appName: this.props.app.name }),
      modalBodyText: t("platformService.serviceApp.endPointModal.endPointBody"),
      modalAcceptBtn: t("platformService.serviceApp.endPointModal.endPointAcceptBtn"),
      modalCancelBtn: t("kubernetesSettings.deleteModal.deleteCancelBtn"),
      endPointsModal: !prevState.endPointsModal
    }));
  }

  handleEndpoints(
    terminalBlocked,
    appEditable,
    endpointID,
    appCredentials) {

    const t = this.props.t;
    let isAdmin = this.state.appSecIsAdmin

    if (terminalBlocked || appEditable === false) {
      return (
        <i
          id={'endpoint-' + endpointID}
          className="icon-api-big elem-settings-btn disabled"></i>
      )
    } else {
      return (
        <>
          <i
            id={'endpoint-' + endpointID}
            className={terminalBlocked ? "cluster-icon link-disabled" : "cluster-icon"}
            onClick={() => { this.endPointsRequest() }}
            target="_blank"
            rel="noopener noreferrer">
            <i
              className="icon-api-big elem-settings-btn"></i>
            <UncontrolledTooltip
              placement="bottom"
              target={'endpoint-' + endpointID}>{t("platformService.serviceApp.endpoints.title")}</UncontrolledTooltip>
          </i>
          {this.state.endPointsModal ?
            <GenericModal
              id={endpointID}
              name="endPointsModal"
              toggleModal={(e) => { this.toggleModal(e) }}
              acceptOnClick={this.handleRenewTSLCert}
              modalTitleText={this.state.modalTitleText}
              modalBodyText={this.state.modalBodyText}
              modalBodyLink={this.state.modalBodyLink}
              modalExtraText={[
                { label: t("platformService.serviceApp.endPointModal.extraText.endpointProtocols") + appCredentials[4], content: appCredentials[0] },
                { label: t("platformService.serviceApp.endPointModal.extraText.caCrt"), content: appCredentials[1] },
                { label: t("platformService.serviceApp.endPointModal.extraText.tlskey"), content: appCredentials[2] },
                { label: t("platformService.serviceApp.endPointModal.extraText.tlsCrt") + appCredentials[5], content: appCredentials[3] }]}
              modalAcceptBtn={this.state.modalAcceptBtn}
              modalCancelBtn={this.state.modalCancelBtn}
              acceptBtnDisabled={!isAdmin} /> :
            null
          }
        </>
      )
    }
  }

  handleTerminals(terminalBlocked, terminalUrl, terminalID) {
    const t = this.props.t;

    let terminalEnabled = this.state.appSecTerminalEnabled;
    if (terminalBlocked || terminalEnabled === false) {
      return (
        <i
          id={'terminal-' + terminalID}
          className="icon-terminal-min elem-settings-btn disabled"></i>
      )
    } else {
      return (
        <a
          className={terminalBlocked ? "cluster-icon link-disabled" : "cluster-icon"}
          href={terminalUrl}
          target="_blank"
          rel="noopener noreferrer">
          <i
            id={'terminal-' + terminalID}
            className="icon-terminal-min elem-settings-btn"></i>
          <UncontrolledTooltip
            placement="bottom"
            target={'terminal-' + terminalID}
          >{t("platformService.serviceApp.console")}</UncontrolledTooltip>
        </a>
      )
    }
  }

  handleAppComponents = () => {
    const i18n = i18next;
    let components = this.state.appComponents;

    if (components.constructor === Array && components.length !== 0) {
      return (
        <>
          {components.map((appComponent, key) => {
            if (appComponent.show === true &&
              this.state.platformLabels) {
              const componentProtocolsArray = [];
              const componentEnabledProtocolsArray = [];

              if (appComponent.appcomponentprotocols
                && appComponent.appcomponentprotocols.constructor === Array
                && appComponent.appcomponentprotocols.length !== 0) {
                appComponent.appcomponentprotocols.map((compoProtocol) => {
                  if (compoProtocol.enabled === true) {
                    componentEnabledProtocolsArray.push(
                      compoProtocol.id
                    )
                  }
                  componentProtocolsArray.push({
                    id: compoProtocol.id,
                    enabled: compoProtocol.enabled,
                    name: compoProtocol.protocol.name
                  })
                })
              }
              return (
                <AppComponent
                  i18n={i18n}
                  key={`${appComponent.id}-${this.state.componentResetVersions.get(appComponent.id) || 0}`}
                  appId={this.state.appId}
                  appActivation={this.state.appActivation}
                  appState={this.state.appState}
                  appDeployCode={this.state.appDeployCode}
                  deployButtonDisable={this.state.deployButtonDisable}
                  requestDeployLoop={this.requestDeployLoop}
                  appFinishedState={this.props.app.deployfinishedstate}
                  appComponent={appComponent}
                  componentUpdated={this.state.componentUpdated}
                  hexColor={this.props.hexColor}
                  platformStorages={this.state.platformStorages}
                  platformLabels={this.state.platformLabels}
                  componentProtocolId={this.state.componentProtocolId}
                  componentProtocols={componentProtocolsArray}
                  componentEnabledProtocols={componentEnabledProtocolsArray}
                  onDirtyStateChange={this.handleComponentDirtyStateChange}
                  pendingValues={this.state.pendingComponentValues.get(String(appComponent.id)) || null}
                  batchValidationCounter={this.state.batchValidationCounter}
                  interactionBlocked={Boolean(this.props.lockedAppId && String(this.props.lockedAppId) !== String(this.state.appId))}
                  onBlockedInteraction={() => {
                    if (this.props.onBlockedInteraction) this.props.onBlockedInteraction(this.state.appId, this.state.appName);
                  }}
                />
              )
            } else return null
          })}
        </>
      )
    }
  }

  handleRenewTSLCert = () => {
    trackPromise(
      dataService.mutations.renewAppTLSCert(
        this.state.appId
      ).then(
        (datarenewappcert) => {
          if (datarenewappcert !== BackEndConsts.BACKEND_RESPONSE_ERROR) {
            platformNotifMessages(
              datarenewappcert.response.messageinfo.messagelevel,
              datarenewappcert.response.messageinfo.messagetitle,
              datarenewappcert.response.messageinfo.message
            );
            this.setState(prevState => ({
              endPointsModal: !prevState.endPointsModal
            }));

            //Call to refresh deployment data every X seconds until state not being UPDATING
            this.requestDeployLoop("UPDATING", this.state.appId, 5000)
          } else {
            this.setState(prevState => ({
              endPointsModal: !prevState.endPointsModal
            }));
          }
        }
      )
    )
  }

  renderSettingsSection(appid, appEditable) {
    let isAdmin = this.state.appSecIsAdmin;
    //This if else clause seems it could be refactored easily but if i remove those else return in doesn't works as expected...
    if (appEditable === true && isAdmin) {
      if (this.state.appState !== "UPDATING") {
        return (
          <>
            <i
              onClick={() => {
                this.toggleSettingsSection()
              }}
              id={'content-' + appid}
              className={`elem-settings-btn ${this.state.settingsOpened ?
                'icon-close expanded' : 'icon-configuration'}`} />
          </>
        );
      } else return (
        <>
          <i
            id={'content-' + appid}
            className="elem-settings-btn icon-configuration disabled" />
        </>
      );
    } else return (
      <>
        <i
          id={'content-' + appid}
          className="elem-settings-btn icon-configuration disabled" />
      </>
    );
  }

  renderDeploymentInfo() {
    const { t, language } = i18next;
    const { appDeployCode, appDeployStatus, appDeployOwner, appDeployDate, appDeployDuration, appNotifError, appId } = this.state;

    if (!appDeployCode || appDeployCode === BackEndConsts.DEPLOYMENT_STATE_NEVERDEPLOYED) {
      return <span className="app-status-label">{appDeployStatus}</span>;
    }

    const isEusLanguage = language === "eus";
    const isRolledBack = appDeployCode === BackEndConsts.DEPLOYMENT_STATE_ROLLEDBACK;
    const spanId = isRolledBack ? `DeployFinishState-${appId}` : '';

    const getTooltip = () => (
      <UncontrolledTooltip
        placement="bottom"
        target={`DeployFinishState-${appId}`}>
        {appNotifError}
      </UncontrolledTooltip>
    );

    return (
      <span className="app-status-label">
        {t("common.deploymentLegend.part1")}
        <span id={spanId} className={`app-status-msg ${isEusLanguage ? 'app-msg-email' : 'app-msg-highlighted'}`}>
          {isEusLanguage
            ? t("common.deploymentLegend.part1_param", { DeployBy: appDeployOwner })
            : isRolledBack
              ? <span className="app-status-info">{t("common.deploymentLegend.part1_param", { DeployCodeInfo: appDeployStatus })}</span>
              : t("common.deploymentLegend.part1_param", { DeployCodeInfo: appDeployStatus })
          }
        </span>
        {t("common.deploymentLegend.part2", { DeployDate: appDeployDate })}
        {!isEusLanguage
          ? <span className={`app-status-msg ${isEusLanguage ? '' : 'app-msg-highlighted'}`}>
            {t("common.deploymentLegend.part2_param", { DeployDate: appDeployDate })}
          </span>
          : t("common.deploymentLegend.part2_param")
        }
        {t("common.deploymentLegend.part3")}
        <span id={isEusLanguage && isRolledBack ? `DeployFinishState-${appId}` : ''} className="app-status-msg app-msg-highlighted">
          {isEusLanguage
            ? isRolledBack
              ? <span className="app-status-info">{t("common.deploymentLegend.part3_param", { DeployCodeInfo: appDeployStatus })}</span>
              : t("common.deploymentLegend.part3_param", { DeployCodeInfo: appDeployStatus })
            : t("common.deploymentLegend.part3_param", { DeployDuration: appDeployDuration })
          }
        </span>
        {t("common.deploymentLegend.part4")}
        <span className="app-status-msg app-msg-email">
          {isEusLanguage
            ? t("common.deploymentLegend.part4_param", { DeployDuration: appDeployDuration })
            : t("common.deploymentLegend.part4_param", { DeployBy: appDeployOwner })
          }
        </span>
        {isEusLanguage && t("common.deploymentLegend.part5")}
        {isRolledBack && getTooltip()}
      </span>
    );
  }


  // Batch editing: handle dirty state changes from child components
  handleComponentDirtyStateChange = (componentId, componentName, isDirty, values, isValid = true, validationErrors = {}) => {
    debugLog("dirty", "app:", this.state.appName, "componentId:", componentId, "isDirty:", isDirty, "isValid:", isValid);
    if (isDirty) {
      // Component has unsaved changes, add to map
      this.setState(prevState => {
        const newDirtyComponents = new Map(prevState.dirtyComponents);
        newDirtyComponents.set(componentId, {
          componentName,
          values,
          isValid,
          validationErrors,
          timestamp: Date.now()
        });
        return { dirtyComponents: newDirtyComponents };
      }, () => {
        debugLog("dirty", "map size:", this.state.dirtyComponents.size, "ids:", Array.from(this.state.dirtyComponents.keys()));
        if (this.props.onAppDirtyStateChange) {
          this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, this.state.dirtyComponents.size > 0);
        }
      });
    } else {
      // Component saved or reverted, remove from map
      this.setState(prevState => {
        const newDirtyComponents = new Map(prevState.dirtyComponents);
        newDirtyComponents.delete(componentId);
        return { dirtyComponents: newDirtyComponents };
      }, () => {
        debugLog("dirty", "map size:", this.state.dirtyComponents.size, "ids:", Array.from(this.state.dirtyComponents.keys()));
        if (this.props.onAppDirtyStateChange) {
          this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, this.state.dirtyComponents.size > 0);
        }
      });
    }
  }

  handleRevertComponent = (componentId) => {
    this.setState(prevState => {
      const newDirtyComponents = new Map(prevState.dirtyComponents);
      newDirtyComponents.delete(componentId);

      const newResetVersions = new Map(prevState.componentResetVersions);
      const currentVersion = newResetVersions.get(componentId) || 0;
      newResetVersions.set(componentId, currentVersion + 1);

      const newPendingValues = new Map(prevState.pendingComponentValues);
      newPendingValues.delete(String(componentId));

      return {
        dirtyComponents: newDirtyComponents,
        pendingComponentValues: newPendingValues,
        componentResetVersions: newResetVersions
      };
    }, () => {
      // If no more dirty components, close modal
      if (this.state.dirtyComponents.size === 0 && this.state.batchSaveModalOpen) {
        this.toggleBatchSaveModal();
      }
      if (this.props.onAppDirtyStateChange) {
        this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, this.state.dirtyComponents.size > 0);
      }
    });
  }

  handleDiscardAll = () => {
    this.setState(prevState => {
      const newResetVersions = new Map(prevState.componentResetVersions);
      // Increment version for all dirty components to force reset
      prevState.dirtyComponents.forEach((_, componentId) => {
        const currentVersion = newResetVersions.get(componentId) || 0;
        newResetVersions.set(componentId, currentVersion + 1);
      });

      return {
        dirtyComponents: new Map(),
        pendingComponentValues: new Map(),
        componentResetVersions: newResetVersions,
        batchSaveModalOpen: false
      };
    }, () => {
      if (this.props.onAppDirtyStateChange) {
        this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, false);
      }
    });
  }

  // Returns the names of dirty components that currently hold invalid values
  // (failed schema validation or a missing required label). Used both to disable
  // the "Update" action and to warn the user which components need fixing.
  getBatchInvalidComponents = () => {
    const invalid = [];
    this.state.dirtyComponents.forEach((data) => {
      const values = data.values || {};
      const labelMissing = !values.componentLabelId || String(values.componentLabelId).trim() === "";
      if (data.isValid === false || labelMissing) {
        invalid.push(data.componentName);
      }
    });
    return invalid;
  }

  normalizeBatchValue = (val, type) => {
    if (val === null || val === undefined) return type === 'bool' ? false : '';
    if (type === 'bool') return val === true || val === 'true';
    const strVal = String(val);
    if (type === 'cpu') return parseInt(strVal.replace('m', ''), 10) || 0;
    if (type === 'mem') return parseInt(strVal.replace('Mi', ''), 10) || 0;
    return val;
  }

  hasComponentPendingChanges = (original, data) => {
    if (!original || !data || !data.values) return false;

    const newValues = data.values;
    const validationErrors = data.validationErrors || {};
    const labelMissing = !newValues.componentLabelId || String(newValues.componentLabelId).trim() === "";

    if (data.isValid === false && (labelMissing || Object.keys(validationErrors).length > 0)) {
      return true;
    }

    if (Number(newValues.componentPods) !== Number(original.podsnumber || 0)) return true;
    if (this.normalizeBatchValue(newValues.componentCPU, 'cpu') !== this.normalizeBatchValue(original.cpureq, 'cpu')) return true;
    if (this.normalizeBatchValue(newValues.componentCPULimit, 'cpu') !== this.normalizeBatchValue(original.cpulimit, 'cpu')) return true;
    if (this.normalizeBatchValue(newValues.componentMem, 'mem') !== this.normalizeBatchValue(original.memreq, 'mem')) return true;
    if (this.normalizeBatchValue(newValues.componentMemLimit, 'mem') !== this.normalizeBatchValue(original.memlimit, 'mem')) return true;
    if (Boolean(newValues.loadbalancerSwitch) !== Boolean(original.loadbalancer)) return true;

    const originalLabelId = original.k8label ? original.k8label.id : null;
    if (String(newValues.componentLabelId || '') !== String(originalLabelId || '')) return true;

    if (Array.isArray(newValues.componentConfiguration)) {
      const hasConfigChange = newValues.componentConfiguration.some((cfg) => {
        const originalCfg = Array.isArray(original.appcomponentconfigs)
          ? original.appcomponentconfigs.find((c) => String(c.id) === String(cfg.id))
          : null;
        const configType = cfg.configtype || (originalCfg && originalCfg.configtype);
        return !areConfigValuesEqual(
          originalCfg ? originalCfg.value : "",
          cfg.value,
          configType
        );
      });
      if (hasConfigChange) return true;
    }

    if (Array.isArray(newValues.componentSecrets)) {
      const hasSecretChange = newValues.componentSecrets.some((sec) => {
        const originalSec = Array.isArray(original.appcomponentsecrets)
          ? original.appcomponentsecrets.find((s) => String(s.id) === String(sec.id))
          : null;
        return String(sec.value ?? '') !== String(originalSec ? (originalSec.value ?? '') : '');
      });
      if (hasSecretChange) return true;
    }

    return false;
  }

  pruneStaleDirtyComponents = (dirtyComponents, appComponents) => {
    const pruned = new Map(dirtyComponents);
    pruned.forEach((data, componentId) => {
      const original = appComponents.find((c) => String(c.id) === String(componentId));
      if (!this.hasComponentPendingChanges(original, data)) {
        pruned.delete(componentId);
      }
    });
    return pruned;
  }

  // Renders the "old value -> new value" list for a set of pending component
  // changes. Shared by the batch update modal and the post-rollback modal, which
  // only differ in their baseline (current server data vs. pre-attempt snapshot).
  renderComponentChanges = (entries, baselineComponents, options = {}) => {
    const t = this.props.t;
    const showRevert = options.showRevert === true;

    return (
      <div className="dirty-components-list">
        {entries.map(([componentId, data]) => {
          const original = baselineComponents.find(c => String(c.id) === String(componentId));
          const newValues = data.values;
          const changes = [];
          const validationErrors = data.validationErrors || {};

          if (!original || !newValues) return null;

          // Helper to normalize values for comparison
          const normalizeValue = (val, type) => {
            if (val === null || val === undefined) return '';
            const strVal = String(val);
            if (type === 'cpu') return parseInt(strVal.replace('m', ''), 10) || 0;
            if (type === 'mem') return parseInt(strVal.replace('Mi', ''), 10) || 0;
            if (type === 'bool') return val === true || val === 'true';
            return val;
          };

          // Helper to format values for display
          const formatValue = (val, type) => {
            if (val === null || val === undefined) return '';
            if (type === 'cpu') return `${val}m`;
            if (type === 'mem') return `${val}Mi`;
            if (type === 'bool') return val ? (t("common.on") || "ON") : (t("common.off") || "OFF");
            return val;
          };

          // Helper to compare and push changes. When the field has a validation
          // error, the change is always shown, flagged as invalid, and the error
          // message is attached so the user sees exactly what is wrong.
          const checkChange = (field, labelKey, originalVal, newVal, type, formikField) => {
            const fieldError = formikField ? validationErrors[formikField] : null;
            const normOriginal = normalizeValue(originalVal, type);
            const normNew = normalizeValue(newVal, type);

            if (fieldError) {
              changes.push({
                field,
                label: t(labelKey),
                oldVal: formatValue(normOriginal, type),
                newVal: formatValue(normNew, type),
                error: fieldError,
                invalid: true
              });
              return;
            }

            if (normOriginal != normNew) {
              changes.push({
                field,
                label: t(labelKey),
                oldVal: formatValue(normOriginal, type),
                newVal: formatValue(normNew, type)
              });
            }
          };

          // Helper for numeric resource fields: when invalid it shows the exact
          // raw value the user typed (e.g. "-1" or "!!!!") instead of a coerced
          // one, plus the validation message underneath.
          const checkResourceChange = (field, labelKey, originalVal, formikField, type) => {
            const rawNew = newValues[formikField];
            const fieldError = validationErrors[formikField];

            if (fieldError) {
              changes.push({
                field,
                label: t(labelKey),
                oldVal: formatValue(normalizeValue(originalVal, type), type),
                newVal: (rawNew === undefined || rawNew === null) ? '' : String(rawNew),
                error: fieldError,
                invalid: true
              });
              return;
            }

            const normOriginal = normalizeValue(originalVal, type);
            const normNew = normalizeValue(rawNew, type);
            if (normOriginal != normNew) {
              changes.push({
                field,
                label: t(labelKey),
                oldVal: formatValue(normOriginal, type),
                newVal: formatValue(normNew, type)
              });
            }
          };

          checkResourceChange('pods', "platformService.serviceApp.batchSaveModal.pods", original.podsnumber, 'componentPods');
          checkResourceChange('cpu', "platformService.serviceApp.batchSaveModal.cpu", original.cpureq, 'componentCPU', 'cpu');
          checkResourceChange('cpuLimit', "platformService.serviceApp.batchSaveModal.cpuLimit", original.cpulimit, 'componentCPULimit', 'cpu');
          checkResourceChange('mem', "platformService.serviceApp.batchSaveModal.mem", original.memreq, 'componentMem', 'mem');
          checkResourceChange('memLimit', "platformService.serviceApp.batchSaveModal.memLimit", original.memlimit, 'componentMemLimit', 'mem');
          checkChange('loadbalancer', "platformService.serviceApp.appComponent.resourceSettings.loadBalancerControl.label", original.loadbalancer, newValues.loadbalancerSwitch, 'bool');
          // Label comparison might need more care if it's an object in original
          const originalLabelId = original.k8label ? original.k8label.id : null;
          checkChange('label', "platformService.serviceApp.appComponent.labelDropdown.title", originalLabelId, newValues.componentLabelId, undefined, 'componentLabel');

          if (Array.isArray(newValues.componentConfiguration)) {
            newValues.componentConfiguration.forEach(cfg => {
              const originalCfg = Array.isArray(original.appcomponentconfigs)
                ? original.appcomponentconfigs.find(c => String(c.id) === String(cfg.id))
                : null;
              const originalValue = originalCfg ? (originalCfg.value ?? '') : '';
              const nextValue = cfg.value ?? '';
              const configType = cfg.configtype || (originalCfg && originalCfg.configtype);
              const label = cfg.publicname || (originalCfg && originalCfg.publicname) || 'Config';

              if (isKeyValueConfig({ configtype: configType })) {
                const entries = diffKeyValueConfig(originalValue, nextValue);
                if (entries.length === 0) return;
                changes.push({
                  field: 'config',
                  kind: 'keyvalue',
                  label,
                  entries
                });
                return;
              }

              if (areConfigValuesEqual(originalValue, nextValue, configType)) return;
              changes.push({
                field: 'config',
                label,
                oldVal: originalValue,
                newVal: nextValue
              });
            });
          }

          if (Array.isArray(newValues.componentSecrets)) {
            newValues.componentSecrets.forEach(sec => {
              const originalSec = Array.isArray(original.appcomponentsecrets)
                ? original.appcomponentsecrets.find(s => String(s.id) === String(sec.id))
                : null;
              if (String(sec.value ?? '') === String(originalSec ? (originalSec.value ?? '') : '')) return;
              changes.push({
                field: 'secret',
                label: sec.name || (originalSec && originalSec.name) || 'Secret',
                oldVal: originalSec ? (originalSec.value || ''): '',
                newVal: sec.value || ''
              });
            });
          }

          if (changes.length === 0) return null;

          return (

            <div key={componentId} className="dirty-component-item">
              <div className="component-header">
                <span className="component-name">{data.componentName}</span>
                {showRevert && (
                  <Button
                    color={this.context}
                    className="btn-sm btn-revert"
                    onClick={() => this.handleRevertComponent(componentId)}
                    title={t("common.revert")}
                  >
                    <i className="icon-undo"></i>
                  </Button>
                )}
              </div>
              <div className="component-changes">
                {changes.map((change, idx) => (
                  change.kind === 'keyvalue' ? (
                    <div key={idx} className="change-item change-item-keyvalue">
                      <span className="change-label">{change.label}:</span>
                      <div className="change-keyvalue-entries">
                        {change.entries.map((entry) => (
                          <div key={entry.key} className="change-item-row">
                            {entry.key ? <span className="change-kv-key">{entry.key}:</span> : null}
                            <span className="change-old">{entry.oldVal}</span>
                            <span className="change-arrow">→</span>
                            <span className="change-new">{entry.newVal}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div key={idx} className={`change-item${change.invalid ? " change-item-invalid" : ""}`}>
                      <div className="change-item-row">
                        <span className="change-label">{change.label}:</span>
                        <span className="change-old">{change.oldVal}</span>
                        <span className="change-arrow">→</span>
                        <span className={`change-new${change.invalid ? " change-new-invalid" : ""}`}>{change.newVal}</span>
                      </div>
                      {change.error && (
                        <div className="change-error">{change.error}</div>
                      )}
                    </div>
                  )
                ))}
              </div>
            </div>
          );
        })
        }
      </div>
    );
  }

  getBatchSaveModalContent = () => {
    const { dirtyComponents, appComponents } = this.state;
    const t = this.props.t;
    const invalidComponents = this.getBatchInvalidComponents();

    return (
      <div className="batch-save-modal-content">
        <p className="modal-intro">{t("platformService.serviceApp.batchSaveModal.intro", { appName: this.state.appName })}</p>
        {invalidComponents.length > 0 && (
          <div className="batch-invalid-warning" role="alert">
            <i className="icon-alert batch-invalid-icon" aria-hidden="true"></i>
            <div className="batch-invalid-body">
              <p className="batch-invalid-title">{t("platformService.serviceApp.batchSaveModal.invalidWarning")}</p>
              <ul className="batch-invalid-list">
                {invalidComponents.map((name, i) => (
                  <li key={i}>{name}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {this.renderComponentChanges(
          Array.from(dirtyComponents.entries()),
          appComponents,
          { showRevert: true }
        )}
      </div >
    );
  }

  getRollbackModalContent = () => {
    const t = this.props.t;
    const snapshot = this.state.rollbackSnapshot;
    if (!snapshot) return null;

    const key = (name) => `platformService.serviceApp.rollbackModal.${name}`;

    return (
      <div className="batch-save-modal-content rollback-modal-content">
        <p className="modal-intro">{t(key("intro"), { appName: this.state.appName })}</p>
        {this.state.rollbackReason && (
          <div className="batch-invalid-warning" role="alert">
            <i className="icon-alert batch-invalid-icon" aria-hidden="true"></i>
            <div className="batch-invalid-body">
              <p className="batch-invalid-title">{t(key("reasonTitle"))}</p>
              <p className="rollback-reason-text">{this.state.rollbackReason}</p>
            </div>
          </div>
        )}
        <p className="rollback-changes-title">{t(key("changesTitle"))}</p>
        {this.renderComponentChanges(snapshot.entries, snapshot.baseline, { showRevert: false })}
        <ul className="rollback-options">
          <li>
            <span className="rollback-option-name">{t(key("keep"))}</span>
            <span className="rollback-option-help">{t(key("keepHelp"))}</span>
          </li>
          <li>
            <span className="rollback-option-name">{t(key("discard"))}</span>
            <span className="rollback-option-help">{t(key("discardHelp"))}</span>
          </li>
        </ul>
        <p className="rollback-close-note">{t(key("closeNote"))}</p>
      </div >
    );
  }

  toggleBatchSaveModal = () => {
    this.setState((prevState) => {
      const prunedDirty = this.pruneStaleDirtyComponents(
        prevState.dirtyComponents,
        prevState.appComponents
      );
      const willOpen = !prevState.batchSaveModalOpen && prunedDirty.size > 0;

      return {
        dirtyComponents: prunedDirty,
        batchSaveModalOpen: willOpen ? true : false
      };
    }, () => {
      if (this.props.onAppDirtyStateChange) {
        this.props.onAppDirtyStateChange(
          this.state.appId,
          this.state.appName,
          this.state.dirtyComponents.size > 0
        );
      }
    });
  }

  // Batch editing: save all dirty components
  handleBatchSave = () => {
    const t = this.props.t;

    // Defense in depth: never deploy while any component holds invalid values,
    // even if the disabled "Update" button were somehow bypassed.
    if (this.getBatchInvalidComponents().length > 0) {
      this.setState(prevState => ({
        batchValidationCounter: prevState.batchValidationCounter + 1
      }));
      return;
    }

    this.setState(prevState => ({
      batchValidationCounter: prevState.batchValidationCounter + 1
    }), () => {
      const { dirtyComponents, appId } = this.state;
      const infraUpdates = [];
      const configUpdates = [];
      const secretUpdates = [];
      let hasBlockingErrors = false;

      dirtyComponents.forEach((data, componentId) => {
        const { values, isValid } = data;
        const labelMissing = !values.componentLabelId || String(values.componentLabelId).trim() === "";

        if (labelMissing) {
          platformNotifMessages(
            "DANGER",
            t("common.error"),
            `${data.componentName}: ${t("platformService.serviceApp.appComponent.labelDropdown.errorMessage")}`,
            data.componentName
          );
          hasBlockingErrors = true;
          return;
        }

        if (isValid === false) {
          platformNotifMessages('DANGER', 'Validation Error', `Component ${data.componentName} has errors and cannot be saved.`, data.componentName);
          hasBlockingErrors = true;
          return;
        }

        infraUpdates.push({
          componentId,
          componentPods: values.componentPods,
          loadBalancer: values.loadbalancerSwitch,
          componentCPU: values.componentCPU,
          componentCPULimit: values.componentCPULimit,
          componentMem: values.componentMem,
          componentMemLimit: values.componentMemLimit,
          componentLabelId: values.componentLabelId,
          componentProtocol: values.filteredComponentProtocols,
          componentPersistences: values.persistenceData
        });

        if (values.componentConfiguration) {
          values.componentConfiguration.forEach(config => {
            if (config.isDirty) {
              configUpdates.push({
                componentId,
                id: config.id,
                value: config.value,
                name: config.publicname
              });
            }
          });
        }

        if (values.componentSecrets) {
          values.componentSecrets.forEach(secret => {
            if (secret.isDirty) {
              secretUpdates.push({
                componentId,
                id: secret.id,
                value: secret.value,
                name: secret.name
              });
            }
          });
        }
      });

      if (hasBlockingErrors) {
        return;
      }

      // Captured before the optimistic update so a rollback can offer the attempted
      // values back together with the values that were actually deployed.
      this.deployAttemptSnapshot = this.buildDeployAttemptSnapshot(dirtyComponents, this.state.appComponents);

      if (this.state.batchSaveModalOpen) {
        this.toggleBatchSaveModal();
      }

      trackPromise(
        dataService.mutations.batchUpdateAppComponentsAndDeployApp(appId, infraUpdates, configUpdates, secretUpdates).then(batchResponse => {
          if (batchResponse === BackEndConsts.BACKEND_RESPONSE_ERROR) return;

        const isOkResponse = (resp) => {
          if (!resp) return false;
          const codeNum = resp.code !== undefined && resp.code !== null ? Number(resp.code) : null;
          if (codeNum === BackEndConsts.RESPONSE_SUCCESS) return true;
          const msg = typeof resp.message === "string" ? resp.message.trim().toUpperCase() : "";
          if (msg === "OK") return true;
          const messageCode = resp.messageinfo && resp.messageinfo.messagecode ? String(resp.messageinfo.messagecode) : "";
          if (messageCode === BackEndConsts.DEMO_DEPLOY_MESSAGECODE) return true;
          const level = resp.messageinfo && resp.messageinfo.messagelevel ? resp.messageinfo.messagelevel : null;
          if (level === "SUCCESS") return true;
          return false;
        };

        const results = (batchResponse && Array.isArray(batchResponse.results)) ? batchResponse.results.map(r => {
          const responsePayload = r && r.response ? { response: r.response, appcomponent: r.appcomponent } : null;
          const ok = responsePayload
            && (Boolean(responsePayload.appcomponent) || (responsePayload.response && isOkResponse(responsePayload.response)));
          return {
            componentId: r.componentid,
            type: 'batch',
            success: Boolean(ok),
            response: responsePayload
          };
        }) : [];

        const overallOk = Boolean(
          (batchResponse && batchResponse.response && isOkResponse(batchResponse.response))
          || (batchResponse && Array.isArray(batchResponse.results) && batchResponse.results.some(r => r && r.appcomponent))
        );

        const touchedComponentIdsSet = new Set();
        infraUpdates.forEach(u => touchedComponentIdsSet.add(String(u.componentId)));
        configUpdates.forEach(u => touchedComponentIdsSet.add(String(u.componentId)));
        secretUpdates.forEach(u => touchedComponentIdsSet.add(String(u.componentId)));

        debugLog("batch", "overallOk:", overallOk, "results:", results.length, "touched:", Array.from(touchedComponentIdsSet));

        const componentResults = new Map();
        let globalSuccess = false;

        results.forEach(result => {
          const cId = String(result.componentId);
          if (!componentResults.has(cId)) {
            componentResults.set(cId, { success: true, responses: [] });
          }
          const cr = componentResults.get(cId);
          if (!result.success) cr.success = false;
          cr.responses.push(result);

          if (result.success) globalSuccess = true;
        });

        if (overallOk) {
          touchedComponentIdsSet.forEach((cId) => {
            if (!componentResults.has(cId)) {
              componentResults.set(cId, { success: true, responses: [] });
            }
          });
          if (touchedComponentIdsSet.size > 0) {
            globalSuccess = true;
          }
        }

        // Collect IDs of successfully updated components
        const successfullyUpdatedComponentIds = [];
        const summaryByComponentId = new Map();
        let hasFailures = false;
        let anyMessageInfo = null;

        componentResults.forEach((status, cId) => {
          if (status.success) {
            successfullyUpdatedComponentIds.push(cId);
          }

          const dirtyEntry = dirtyComponents.get(cId) || dirtyComponents.get(parseInt(cId, 10));
          const componentName = dirtyEntry ? dirtyEntry.componentName : '';

          let success = status.success;
          let messageInfo = null;

          status.responses.forEach(r => {
            const mi = r && r.response && r.response.response && r.response.response.messageinfo ? r.response.response.messageinfo : null;
            if (!r.success) success = false;
            if (!messageInfo && mi) messageInfo = mi;
          });

          if (!anyMessageInfo && messageInfo) anyMessageInfo = messageInfo;

          if (!summaryByComponentId.has(cId)) {
            summaryByComponentId.set(cId, { componentName, success, messageInfo });
          } else {
            const prev = summaryByComponentId.get(cId);
            summaryByComponentId.set(cId, {
              componentName: prev.componentName || componentName,
              success: Boolean(prev.success && success),
              messageInfo: prev.messageInfo || messageInfo
            });
          }

          if (!status.success) hasFailures = true;
        });

        const topMessageInfo = batchResponse && batchResponse.response && batchResponse.response.messageinfo ? batchResponse.response.messageinfo : null;
        const effectiveMessageInfo = topMessageInfo || anyMessageInfo;

        if (touchedComponentIdsSet.size > 0 && effectiveMessageInfo) {
          const componentNames = [];
          touchedComponentIdsSet.forEach((cId) => {
            const entry = summaryByComponentId.get(String(cId));
            const name = entry && entry.componentName ? entry.componentName : '';
            if (name) componentNames.push(name);
          });

          const failedNames = [];
          summaryByComponentId.forEach((entry) => {
            if (!entry.success && entry.componentName) failedNames.push(entry.componentName);
          });

          const titleBase = effectiveMessageInfo.messagetitle || 'Batch update';
          const finalTitle = `${this.state.appName} - ${titleBase}`;

          const messageParts = [];
          if (effectiveMessageInfo.message) messageParts.push(effectiveMessageInfo.message);
          if (componentNames.length) messageParts.push(`Components: ${componentNames.join(", ")}`);
          if (failedNames.length) messageParts.push(`Failed: ${failedNames.join(", ")}`);

          const msg = messageParts.join(" | ");
          const level = hasFailures ? "DANGER" : (effectiveMessageInfo.messagelevel || "SUCCESS");
          platformNotifMessages(level, finalTitle, msg);
        }

        if (globalSuccess) {
          // Force reset of successfully updated components
          this.setState(prevState => {
            const newResetVersions = new Map(prevState.componentResetVersions);

            const successfulIdsSet = (overallOk && touchedComponentIdsSet.size > 0)
              ? new Set(Array.from(touchedComponentIdsSet))
              : new Set(successfullyUpdatedComponentIds.map(id => String(id)));

            const updatedAppComponents = Array.isArray(prevState.appComponents)
              ? prevState.appComponents.map((component) => {
                if (!component || !successfulIdsSet.has(String(component.id))) return component;

                const dirtyEntry =
                  prevState.dirtyComponents.get(component.id) ||
                  prevState.dirtyComponents.get(String(component.id));

                const mutationData = dirtyEntry ? dirtyEntry.values : null;
                if (!mutationData) return component;

                const labelObj = Array.isArray(prevState.platformLabels)
                  ? prevState.platformLabels.find(l => String(l.id) === String(mutationData.componentLabelId))
                  : null;

                const findStorageById = (id) => {
                  if (!Array.isArray(prevState.platformStorages) || id == null) return null;
                  return prevState.platformStorages.find(s => String(s.id) === String(id)) || null;
                };

                const updatedProtocols = Array.isArray(component.appcomponentprotocols)
                  ? component.appcomponentprotocols.map((p) => {
                    const match = Array.isArray(mutationData.filteredComponentProtocols)
                      ? mutationData.filteredComponentProtocols.find(mp => String(mp.id) === String(p.id))
                      : null;
                    if (!match) return p;
                    return { ...p, enabled: match.enabled };
                  })
                  : component.appcomponentprotocols;

                const updatedPersistences = Array.isArray(component.appcomponentpersistences)
                  ? component.appcomponentpersistences.map((p) => {
                    const match = Array.isArray(mutationData.persistenceData)
                      ? mutationData.persistenceData.find(mp => String(mp.idpersistence) === String(p.id))
                      : null;
                    if (!match) return p;

                    const storage = findStorageById(match.idstorage);
                    const parsedSize = parseInt(String(match.size).replace('Gi', ''), 10);
                    const sizeValue = Number.isFinite(parsedSize) ? parsedSize : match.size;

                    const k8storage = storage
                      ? { id: storage.id, publicname: storage.publicname }
                      : (p.k8storage ? { ...p.k8storage, id: match.idstorage } : { id: match.idstorage });

                    return { ...p, size: sizeValue, k8storage };
                  })
                  : component.appcomponentpersistences;

                const updatedConfigs = Array.isArray(component.appcomponentconfigs)
                  ? component.appcomponentconfigs.map((cfg) => {
                    const match = Array.isArray(mutationData.componentConfiguration)
                      ? mutationData.componentConfiguration.find(mc => String(mc.id) === String(cfg.id))
                      : null;
                    if (!match) return cfg;
                    return { ...cfg, value: match.value };
                  })
                  : component.appcomponentconfigs;

                const updatedSecrets = Array.isArray(component.appcomponentsecrets)
                  ? component.appcomponentsecrets.map((sec) => {
                    const match = Array.isArray(mutationData.componentSecrets)
                      ? mutationData.componentSecrets.find(ms => String(ms.id) === String(sec.id))
                      : null;
                    if (!match) return sec;
                    return { ...sec, value: match.value };
                  })
                  : component.appcomponentsecrets;

                return {
                  ...component,
                  podsnumber: mutationData.componentPods,
                  loadbalancer: mutationData.loadbalancerSwitch,
                  cpureq: mutationData.componentCPU != null ? String(mutationData.componentCPU) : component.cpureq,
                  cpulimit: mutationData.componentCPULimit != null ? String(mutationData.componentCPULimit) : component.cpulimit,
                  memreq: mutationData.componentMem != null ? String(mutationData.componentMem) : component.memreq,
                  memlimit: mutationData.componentMemLimit != null ? String(mutationData.componentMemLimit) : component.memlimit,
                  k8label: labelObj ? { id: labelObj.id, name: labelObj.name } : component.k8label,
                  appcomponentprotocols: updatedProtocols,
                  appcomponentpersistences: updatedPersistences,
                  appcomponentconfigs: updatedConfigs,
                  appcomponentsecrets: updatedSecrets
                };
              })
              : prevState.appComponents;

            // Rebuild dirtyComponents map, excluding successful ones
            const remainingDirtyComponents = new Map();

            const forceClearDirtyComponents = Boolean(overallOk && touchedComponentIdsSet.size > 0);

            if (successfullyUpdatedComponentIds.length === prevState.dirtyComponents.size || forceClearDirtyComponents) {
               // All successful, remaining is empty
            } else {
               prevState.dirtyComponents.forEach((value, key) => {
                 if (!successfulIdsSet.has(String(key))) {
                   remainingDirtyComponents.set(key, value);
                 } else {
                   // If successful, increment version to force remount
                   const currentVersion = newResetVersions.get(key) || 0;
                   newResetVersions.set(key, currentVersion + 1);
                 }
               });
            }

            // For logic where we emptied the map via optimization, we still need to update reset versions
            if (forceClearDirtyComponents) {
              prevState.dirtyComponents.forEach((_, originalKey) => {
                if (successfulIdsSet.has(String(originalKey))) {
                  const currentVersion = newResetVersions.get(originalKey) || 0;
                  newResetVersions.set(originalKey, currentVersion + 1);
                }
              });
            } else if (successfullyUpdatedComponentIds.length === prevState.dirtyComponents.size) {
                 successfulIdsSet.forEach(key => {
                     // The set contains strings, we need to handle that map keys might be numbers or strings
                     // But resetVersions uses the same keys as dirtyComponents usually
                     // Let's iterate original map to be safe
                     prevState.dirtyComponents.forEach((_, originalKey) => {
                         if (successfulIdsSet.has(String(originalKey))) {
                             const currentVersion = newResetVersions.get(originalKey) || 0;
                             newResetVersions.set(originalKey, currentVersion + 1);
                         }
                     });
                 });
            }

            // If no dirty components left, close modal
            let modalOpen = prevState.batchSaveModalOpen;
            if (remainingDirtyComponents.size === 0) {
                modalOpen = false;
            }

            const remainingPendingValues = new Map(prevState.pendingComponentValues);
            successfulIdsSet.forEach((id) => remainingPendingValues.delete(String(id)));

            return {
                componentResetVersions: newResetVersions,
                appComponents: updatedAppComponents,
                dirtyComponents: remainingDirtyComponents,
                pendingComponentValues: remainingPendingValues,
                batchSaveModalOpen: modalOpen
            };
          }, () => {
            debugLog("batch", "dirtyComponents after:", this.state.dirtyComponents.size, "successful:", successfullyUpdatedComponentIds.length);
            if (this.props.onAppDirtyStateChange) {
              this.props.onAppDirtyStateChange(this.state.appId, this.state.appName, this.state.dirtyComponents.size > 0);
            }
          });

          const needsUpdate = Boolean(
            (batchResponse && batchResponse.response && batchResponse.response.messageinfo && batchResponse.response.messageinfo.messagecode === BackEndConsts.DEPLOYMENT_STATE_UPDATING)
            || results.some(r => r.success && r.response && r.response.response && r.response.response.messageinfo && r.response.response.messageinfo.messagecode === BackEndConsts.DEPLOYMENT_STATE_UPDATING)
          );
          if (needsUpdate) {
            this.requestDeployLoop("UPDATING", appId, 5000);
          }
        }
        })
      );
    });
  }

  render() {
    const t = this.props.t;
    let appId = this.props.app.id;
    let notifications = this.state.appNotifications;

    return (
      <>
        <tr key={this.state.appId}>
          <td>
            <span className="switch-control">
              {this.renderSwitchButton()}
            </span>
          </td>
          <td className="app-name">
            {this.state.appName}
            {this.state.dirtyComponents.size > 0 && <span className="dirty-indicator" title={t("common.unsavedChanges")} />}
          </td>
          <td>
            <ul className="cluster-list serviceapp-cluster">
              {this.state.appClusters && this.state.appClusters.map((cluster, key) => {
                if (cluster.type === "Service") {
                  return (
                    <li key={key}
                      id={cluster.id}
                      className="cluster-elem">
                      <a
                        className={(this.state.servicesDisabled || this.state.appSecClusterEnabled === false) ? "cluster-icon link-disabled" : "cluster-icon"}
                        href={cluster.url}
                        target="_blank"
                        rel="noopener noreferrer">
                        <i className={cluster.image}></i>
                      </a>
                      <span
                        id={"ClusterTooltip-" + cluster.id}
                        className="cluster-name">{cluster.name}</span>
                      <UncontrolledTooltip
                        placement="right"
                        target={"ClusterTooltip-" + cluster.id}
                      >{cluster.tooltip}</UncontrolledTooltip>
                    </li>
                  )
                } else return null
              })}
            </ul>
          </td>
          <td
            className="administration-column-set">
            {this.state.appK8Endpoints && this.state.appK8Endpoints.map((k8endpoint) => {
              if (k8endpoint.type === "public") {
                return (
                  <>
                    {this.handleEndpoints(
                      this.state.servicesDisabled,
                      this.state.appEditable,
                      k8endpoint.id,
                      [
                        k8endpoint.domain,
                        this.state.platformAppCACRT,
                        k8endpoint.clientkey,
                        k8endpoint.clientcrt,
                        k8endpoint.protocols,
                        k8endpoint.certexpirationdate
                      ])
                    }
                  </>
                )
              } else return null
            })}
            {this.state.appClusters && this.state.appClusters.map((cluster, key) => {
              if (cluster.type === "Terminal") {
                return (
                  <>
                    {this.handleTerminals(
                      this.state.servicesDisabled,
                      cluster.url,
                      cluster.id,
                      cluster.name
                    )}
                  </>
                )
              } else return null
            })}
            {this.renderSettingsSection(appId, this.state.appEditable)}
            <UncontrolledTooltip
              placement="bottom"
              target={'content-' + appId}
            >{t("common.settings")}</UncontrolledTooltip>
          </td>
        </tr>
        <tr className="row-separator messaging-wrapper">
          <td colSpan="4" className="noborder">
            <table className="table-status-info">
              <th className="collapsed-row-wrapper header-status-wrapper header-deploystatus">
                {this.renderDeploymentInfo()}
              </th>
              <th className="collapsed-row-wrapper header-status-wrapper header-onlineusers">
                <span className="app-status-label">{t("common.online")}:</span>
                <span className="app-status-msg">{this.state.appOnlineUsers}</span>
              </th>
            </table>
          </td>
        </tr>
        {notifications.length !== 0 &&
          <tr>
            <td colSpan="4" className="noborder">
              <table className="table-lainotik table-notifications">
                <tr className="row-separator messaging-wrapper">
                  <th className="column-header column-name">{t("kubernetesSettings.platformStatusArea.monitoringStatus.tableNotifications.pod")}</th>
                  <th className="column-header column-phase">{t("kubernetesSettings.platformStatusArea.monitoringStatus.tableNotifications.phase")}</th>
                  <th className="column-header column-sche">{t("kubernetesSettings.platformStatusArea.monitoringStatus.tableNotifications.scheduled")}</th>
                  <th className="column-header column-init">{t("kubernetesSettings.platformStatusArea.monitoringStatus.tableNotifications.initialized")}</th>
                  <th className="column-header column-ready">{t("kubernetesSettings.platformStatusArea.monitoringStatus.tableNotifications.ready")}</th>
                </tr>
                {notifications && notifications.map((notif, index) => {
                  return (
                    <tr key={index}>
                      <td className="table-value value-name">{notif.name}</td>
                      <td className="table-value">{notif.phase}</td>
                      <td className="table-value">{notif.podscheduled}</td>
                      <td className="table-value">{notif.initialized}</td>
                      <td className="table-value">{notif.ready}</td>
                    </tr>
                  )
                })}
              </table>
            </td>
          </tr>
        }
        <tr>
          <td className="collapsed-content" colSpan="4">
            <UncontrolledCollapse
              id={'accordion-' + this.props.app.id}
              toggler={'#content-' + this.props.app.id}
              isOpen={this.state.settingsOpened}>
              {this.state.appComponents
                && this.handleAppComponents()}
            </UncontrolledCollapse>
          </td>
        </tr>
        {
          this.state.appActivation === true && this.state.dirtyComponents.size >= 1 && (
            <tr className="fab-batch-edit-row">
              <td colSpan="4" className="noborder">
                <div className="fab-batch-edit">
                  <Button
                    color={this.context}
                    onClick={this.toggleBatchSaveModal}
                  >
                    <i className="icon-save"></i>
                    <span className="fab-text">{t("platformService.serviceApp.batchSave")} - {this.state.appName}</span>
                    <span className="badge">{this.state.dirtyComponents.size}</span>
                  </Button>
                </div>
              </td>
            </tr>
          )
        }
        {this.state.batchSaveModalOpen && (
          <GenericModal
            modalTitleText={t("platformService.serviceApp.batchSaveModal.title", { appName: this.state.appName }) || `Update ${this.state.appName}`}
            modalBodyText={this.getBatchSaveModalContent()}
            modalAcceptBtn={t("platformService.serviceApp.batchSaveModal.apply") || "Update"}
            modalCancelBtn={t("platformService.serviceApp.batchSaveModal.discard") || "Discard"}
            acceptBtnDisabled={this.getBatchInvalidComponents().length > 0}
            acceptOnClick={this.handleBatchSave}
            cancelOnClick={this.handleDiscardAll}
            toggleModal={this.toggleBatchSaveModal}
          />
        )}
        {this.state.rollbackModalOpen && !this.state.rollbackModalConfirmDiscard && (
          <GenericModal
            className="rollback-choice-modal"
            modalTitleText={t("platformService.serviceApp.rollbackModal.title", { appName: this.state.appName })}
            modalBodyText={this.getRollbackModalContent()}
            modalAcceptBtn={t("platformService.serviceApp.rollbackModal.keep")}
            modalCancelBtn={t("platformService.serviceApp.rollbackModal.discard")}
            acceptOnClick={this.handleRollbackKeepValues}
            cancelOnClick={this.handleRollbackDiscardValues}
            toggleModal={this.toggleRollbackModal}
          />
        )}
        {this.state.rollbackModalOpen && this.state.rollbackModalConfirmDiscard && (
          <GenericModal
            modalTitleText={t("platformService.serviceApp.rollbackModal.confirmDiscardTitle")}
            modalBodyText={
              <p className="modal-intro">{t("platformService.serviceApp.rollbackModal.confirmDiscardBody")}</p>
            }
            modalAcceptBtn={t("platformService.serviceApp.rollbackModal.confirmDiscardAccept")}
            modalCancelBtn={t("platformService.serviceApp.rollbackModal.confirmDiscardCancel")}
            acceptOnClick={this.handleRollbackDiscardValues}
            cancelOnClick={this.cancelRollbackDiscardConfirmation}
            toggleModal={this.cancelRollbackDiscardConfirmation}
          />
        )}
      </>
    );
  }
}
export default ServiceApp

ServiceApp.propTypes = {
  components: PropTypes.array
}
